export enum TransferSaleMethod {
  ARA_SAY_S_ = 'AraçSayısı',
  KI_I_SAY_S_ = 'KişiSayısı',
}
